import { translationScopeService } from './translation-scope.service';

/**
 * Helper function to load required translation files after a lazy-loaded code module has been loaded.
 *
 * Usage example:
 * 	const code = await import('some-source-files.ts')
 * 		.then(importTranslations);
 *
 * @param passThru
 * @returns
 */
export async function importTranslations<T>(passThru: T): Promise<T> {
	await translationScopeService.updateAfterImportingCode();
	return Promise.resolve(passThru);
}
